// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cbd87b74","301":"27cc84e5","455":"66a0559d","644":"6fb542db"}[chunkId] + ".chunk.js";
};